module.exports = "<template> AOK-ProFit<br> 70133 Stuttgart </template>";